import { Snapshot } from "@/types/Snapshots";

export function mapSnapshotTranslations(snapshot?: Snapshot) {
  if (!snapshot) {
    return undefined;
  }

  const translations = snapshot.experience_commercial_information?.translations;
  const english_translation = translations?.find((translation) => translation.language_code === "en");

  return {
    ...snapshot,
    english_translation,
  };
}
